'use client';
import { isArray } from 'lodash-es';
import React from 'react';

function ToggleButtonGroup(props) {
  const { value = [], onChange, children, className } = props;

  if (!isArray(value)) {
    throw new Error('value must be an array');
  }

  return (
    <div className={className}>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) {
          return null;
        }

        return React.cloneElement(child, {
          onClick: () => {
            if (child.props.disabled) {
              return;
            }

            const newValue = [...value];
            const index = value.indexOf(child.props.value);

            if (index === -1) {
              newValue.push(child.props.value);
            } else {
              newValue.splice(index, 1);
            }
            if (onChange) {
              onChange(newValue);
            }
          },
          selected: value.includes(child.props.value),
        });
      })}
    </div>
  );
}

export default ToggleButtonGroup;
